import {Stack,} from '@mantine/core';
import {Application,} from '../types';
import {PlatformPropertyCard} from "@flexinet/ui-components";


export const Profile = ({record}: { record: Application }) => {

    const properties = [
        {
            label: 'Name',
            value: record.name as string,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'URL',
            value: record.url as string,
            span: 12,
        }, {
            label: 'Logo URL',
            value: record.logoUrl as string,
            span: 12,
        }];


    const properties2 = [
        {
            label: 'Created',
            value: record.created as string,
            formatAs: 'Timestamp',
            span: 12,
        },
        {
            label: 'Created By',
            value: typeof record.createdBy !== 'undefined' && record.createdBy !== null ? [record.createdBy.givenName, record.createdBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateApplication',
            span: 12,
        },
        {
            label: 'Last Updated',
            value: record.updated as string,
            formatAs: 'Timestamp',
            span: 12,
        }, {
            label: 'Updated By',
            value: typeof record.updatedBy !== 'undefined' && record.updatedBy !== null ? [record.updatedBy.givenName, record.updatedBy.familyName].join(' ') : 'n/a',
            rbac: 'UpdateApplication',
            span: 12,
        }];


    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
